import { z } from 'zod';
import { Platform } from '../enums.js';

export const verifyOtpSchema = z.object({
  mfa_token: z.string().min(1),
  code: z
    .string()
    .length(6)
    .regex(/^\d{6}$/),
  platform: z.enum(Platform).optional(),
});

export type VerifyOtpPayload = z.infer<typeof verifyOtpSchema>;

export const resendOtpSchema = z.object({
  mfa_token: z.string().min(1),
});

export type ResendOtpPayload = z.infer<typeof resendOtpSchema>;
